import * as STD                                         from '@emersya/mpa-std';
import * as CM                                               from '@emersya/mpa-components-manager';

export interface IInputTextMultiLinesComponentConfiguration extends IInputComponentConfiguration<
	string,
	string
>
{
	debouncerDelay? : number | null;
};

export class InputTextMultiLinesComponent extends InputComponent<
	HTMLInputElement,
	string,
	string,
	InputTextMultiLinesComponent,
	IInputTextMultiLinesComponentConfiguration
>
{
	component_DOM : HTMLInputElement;

	override deserialize(x : string) {
		return (x);
	};

	async onTextUpdated() {
		const newValue = this.component_DOM.value;
		await this.updateValue(newValue);
	};

	override isValueTheDefault() {
		return (this.value === this.defaultValue);
	};

	private onValueUpdated(ev : STD.events.Event<any, CM.Component<any, any>>) {
		this.component_DOM.value = ev.details.newValue;
	};

	async reset() {
		await this.updateValue(this.component_configuration.defaultValue || null);
	};

	serialize() {
		return this.value;
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IInputTextMultiLinesComponentConfiguration
	)
	{
		super(descriptor, configuration);
		this.component_DOM = <HTMLInputElement> STD.DOM.factory({
			tag :        'textarea',
			attributes : {},
			events :     {
				input : (
									this.component_configuration.debouncerDelay ? STD.misc.createDebouncer({
											fn :    <() => void><any>this.onTextUpdated.bind(this),
											delay : this.component_configuration.debouncerDelay
										}) :
										this.onTextUpdated.bind(this)
								)
			}
		});

		if (this.component_hasTranslation('placeholder')) {
			this.component_DOM.dataset.translationAttr = 'placeholder:' + this.component_getTranslationId('placeholder');
		}

		this.addEventListener('value', this.onValueUpdated.bind(this), {
			subType :  'input-textMultiLines',
			listener : this
		});
	};
};
export namespace NS {
	export const Component = InputTextMultiLinesComponent;
	export type Component = InputTextMultiLinesComponent;
	export type Configuration = IInputTextMultiLinesComponentConfiguration;
}
;
import { InputComponent, IInputComponentConfiguration } from '../Input/Input';

CM.Manager.declare({
	id :   'input-textMultiLines',
	type : InputTextMultiLinesComponent
});
